import { getUserInfo } from '@/apis/account';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
// import { notification } from 'ant-design-vue';
// import i18n from '@/i18n';
import { useAccountStore } from '@/store/resources/account';

// 校验路由是否需要登录才能访问
export const authCheck = async (to: RouteLocationNormalized, next: NavigationGuardNext) => {
  const accountStore = useAccountStore();

  // 此路由是否需要登录才能访问
  // const needAuth = !!to.meta.needAuth;

  // accessToken
  const accessToken = localStorage.getItem('accessToken');
  // 登录状态
  const userInfo = accountStore.userInfo;

  // 用户未登录, 在跳转前做一些判断
  const redirectWithNotAuth = () => {
    // if (needAuth) {
    //   // 提示用户此页面需要登录
    //   notification.error({
    //     placement: 'bottomLeft',
    //     message: i18n.global.t('common.loginStatusExpired'),
    //     duration: 3.5,
    //   });

    //   // 跳转到登入页
    //   next({
    //     name: 'AccountSignIn',
    //     params: {
    //       i18nParamKey: to.params.i18nParamKey,
    //     },
    //   });
    // } else {
    // 正常跳转
    next();
    // }
  };

  // 用户已经登录, 在跳转前做一些判断
  const redirectWithAuthed = () => {
    // 有 accessToken 访问登录页直接跳到 Home 页面
    if (to.name === 'AccountSignIn') {
      next({
        name: 'SystemHome',
        params: {
          i18nParamKey: to.params.i18nParamKey,
        },
      });
    } else {
      // 正常跳转
      next();
    }
  };

  if (accessToken) {
    if (userInfo) {
      redirectWithAuthed();
    } else {
      try {
        // 获取用户登录状态
        const result = await getUserInfo(accessToken);

        if (result.status !== '0') {
          // 不等于 0 抛出错误, 后续进入到 catch 捕获
          throw new Error();
        }

        accountStore.updateUserInfo(result.data);

        redirectWithAuthed();
      } catch (error: any) {
        console.log('accessToken 存在, 但是登陆状态已失效');

        // 清空 accessToken
        localStorage.removeItem('accessToken');

        redirectWithNotAuth();
      }
    }
  } else {
    redirectWithNotAuth();
  }
};
